import React, { useState, useCallback } from 'react';
import classnames from 'classnames';
import { useSnackbar, SnackbarContent } from 'notistack';
import { Button, Card, CardActions, Collapse, IconButton, Paper, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles(theme => ({
    root: {
        [theme.breakpoints.up('sm')]: {
            minWidth: '344px !important',
            maxWidth: '544px !important',
        },
    },
    card: {
        // backgroundColor: '#FC8900',
        width: '100%',
    },
    typography: {
        fontWeight: 'bold',
    },
    actionRoot: {
        padding: '8px 8px 8px 16px',
        justifyContent: 'space-between',
    },
    icons: {
        marginLeft: 'auto',
    },
    expand: {
        padding: '8px 8px',
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    collapse: {
        padding: 16,
    },
    checkIcon: {
        fontSize: 20,
        color: '#b3b3b3',
        paddingRight: 4,
    },
    button: {
        padding: 0,
        textTransform: 'none',
    },
}));


const CustomSnackbarCollapse = React.forwardRef((props, ref) => {
    const { id, errorMessage, label = "An unexpected error has occurred" } = props;
    const classes = useStyles();
    const { closeSnackbar } = useSnackbar();
    const [expanded, setExpanded] = useState(false);
  
    const handleExpandClick = () => {
      setExpanded(!expanded);
    };
  
    const handleDismiss = () => {
      closeSnackbar(id);
    };
  
    return (
      <SnackbarContent ref={ref} className={classes.root}>
        <Card className={classes.card} style={{backgroundColor:"#D32F2F"}}>
          <CardActions classes={{ root: classes.actionRoot }}>
            <Typography className={classes.typography} style={{ color: "white" }} variant="subtitle2">
              {label}
            </Typography>
            <div className={classes.icons}>
              {errorMessage && (
                <IconButton
                  aria-label="Show Details"
                  className={classnames(classes.expand, { [classes.expandOpen]: expanded })}
                  onClick={handleExpandClick}
                >
                  <ExpandMoreIcon style={{ color: "white" }} />
                </IconButton>
              )}
              <IconButton className={classes.expand} onClick={handleDismiss}>
                <CloseIcon style={{ color: "white" }} />
              </IconButton>
            </div>
          </CardActions>
          <Collapse unmountOnExit in={expanded} timeout="auto">
            <Paper className={classes.collapse}>
              {errorMessage}              
            </Paper>
          </Collapse>
        </Card>
      </SnackbarContent>
    );
  });

export default CustomSnackbarCollapse;